<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">
      <b>{{ isEditMode ? 'Promptu Düzenle' : 'Yeni Prompt' }}</b>
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <form [formGroup]="promptForm">
    <div class="modal-body">
      <div class="form-group">
        <label>Ad <span class="text-danger">*</span></label>
        <input type="text" class="form-control" formControlName="name" placeholder="Prompt adı">
        <div *ngIf="promptForm.get('name').invalid && promptForm.get('name').touched" class="text-danger small mt-1">
          Ad zorunludur.
        </div>
      </div>

      <div class="form-group">
        <label>System Prompt <span class="text-danger">*</span></label>
        <textarea class="form-control" rows="6" formControlName="systemPrompt" placeholder="System prompt içeriği..."></textarea>
        <div *ngIf="promptForm.get('systemPrompt').invalid && promptForm.get('systemPrompt').touched" class="text-danger small mt-1">
          System prompt zorunludur.
        </div>
      </div>

      <div class="form-group">
        <label>User Prompt <span class="text-danger">*</span></label>
        <textarea class="form-control" rows="6" formControlName="userPrompt" placeholder="User prompt içeriği..."></textarea>
        <div *ngIf="promptForm.get('userPrompt').invalid && promptForm.get('userPrompt').touched" class="text-danger small mt-1">
          User prompt zorunludur.
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="close()">Kapat</button>
      <button type="button" class="btn btn-primary" (click)="save()" [disabled]="submitted">
        <i class="fa fa-spinner fa-spin" *ngIf="submitted"></i>
        {{ isEditMode ? 'Güncelle' : 'Kaydet' }}
      </button>
    </div>
  </form>
</div>
